import { Component, Input, OnInit } from '@angular/core';
import {
  FORMAT_FOR_CURRENCY_DIGITS,
  FORMAT_FOR_INTEGER,
  FORMAT_FOR_NUMBER_DIGITS,
} from 'src/app/core/helpers/ui/ui.constant';
import { CardLightDescription } from 'src/app/core/interfaces/ui/components.interface';

@Component({
  selector: 'shared-light-description',
  templateUrl: './light-description.component.html',
  styleUrls: ['./light-description.component.scss'],
})
export class LightDescriptionComponent implements OnInit {
  @Input({ required: true })
  public tag!: CardLightDescription & { click?: () => void };

  @Input()
  public isLoading: boolean = true;

  @Input() format: 'integer' | 'decimal' | 'currency' = 'integer';
  @Input() public currencyCode: string = 'USD';

  public randomSvgColor!: string;

  public FORMAT_FOR_INTEGER = FORMAT_FOR_INTEGER;
  public FORMAT_FOR_NUMBER_DIGITS = FORMAT_FOR_NUMBER_DIGITS;
  public FORMAT_FOR_CURRENCY_DIGITS = FORMAT_FOR_CURRENCY_DIGITS;

  private svgColors = [
    'svg-yellow',
    'svg-blue',
    'svg-green',
    'svg-red',
    'svg-purple',
  ];

  ngOnInit(): void {
    this.assignRandomIconColor();
  }

  private assignRandomIconColor(): void {
    this.randomSvgColor =
      this.svgColors[Math.floor(Math.random() * this.svgColors.length)];
  }

  public onClick(): void {
    if (this.tag?.click) {
      this.tag.click();
    }
  }
}
